module.exports = __webpack_public_path__ + "img/icon-menu-favorite.2498f5e8.svg";